import { compose, pure } from 'recompose';
const EmptyList = (props) => {
    const { list, children, emptyComponent } = props;
    return !list || list.length < 1 ? emptyComponent : children;
};
const ComposedEmptyList = compose(pure)(EmptyList);
ComposedEmptyList.displayName = 'EmptyList';
export default ComposedEmptyList;
//# sourceMappingURL=EmptyList.js.map